import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { RailwayCompanyResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../../libs/axios/appAxios';

// 路線マスタ取得
// パラメータを付与しない場合は全件取得する
export const getRailwayCompany = async (
  params?: { prefctureId: string | string[] | number[] },
  headers?: IncomingHttpHeaders
) => {
  return appAxios({
    url: '/api/v1/railwayCompany',
    headers,
    params,
  }).then((res: AxiosResponse<RailwayCompanyResponse[]>) => {
    return res.data;
  });
};
